import { Box, Skeleton } from '@mui/material';
import { ReleaseToDeconCard } from './ReleaseToDeconCard';
import { loadingCardGridSx } from './styles';

type ResponsiveSize =
  | string
  | number
  | {
      xs?: string | number;
      sm?: string | number;
      md?: string | number;
      lg?: string | number;
      xl?: string | number;
    };

type LoadingCardProps = {
  rows: number;
  height?: number | string;
  titleWidth?: string;
  subtitleWidth?: string;
  cardWidth?: ResponsiveSize;
  cardMaxWidth?: ResponsiveSize;
};

export const LoadingCard = ({
  rows,
  height,
  titleWidth = '40%',
  subtitleWidth = '60%',
  cardWidth,
  cardMaxWidth,
}: LoadingCardProps) => (
  <ReleaseToDeconCard
    sx={{
      height,
      ...(cardWidth ? { width: cardWidth } : {}),
      ...(cardMaxWidth ? { maxWidth: cardMaxWidth } : {}),
    }}
  >
    <Skeleton variant="text" width={titleWidth} height={28}  sx={{ background: 'rgba(0, 0, 0, 0.04)'}} />
    <Skeleton variant="text" width={subtitleWidth} height={32} sx={{ mb: 2, background: 'rgba(0, 0, 0, 0.04)' }} />
    <Box sx={loadingCardGridSx}>
      {[...Array(rows)].map((_, index) => (
        <Skeleton key={index} variant="rounded" height={48} />
      ))}
    </Box>
  </ReleaseToDeconCard>
);
